// import { NextResponse } from "next/server";
import { flattenAttributes, strapiApiKey } from "./util";

const getRequest = async (url, options = {}) => {
  if (options && options?.lang) {
    // Determine if the URL already has query parameters
    const separator = url.includes("?") ? "&" : "?";
    // Append the lang parameter to the URL
    url += `${separator}locale=${options.lang}`;
  }

  options.headers = {
    Authorization: `Bearer ${strapiApiKey}`,
  };

  try {
    const { cache: requestedCache, next: requestedNext, ...requestOptions } = options;
    const method = (requestOptions.method || "GET").toUpperCase();
    const shouldCache =
      method === "GET" &&
      requestedCache !== "no-cache" &&
      requestedCache !== "no-store";
    let response = await fetch(url, {
      ...requestOptions,
      ...(shouldCache
        ? {
            next: {
              ...requestedNext,
              revalidate: requestedNext?.revalidate ?? 300,
            },
          }
        : { cache: "no-store" }),
    });

    response = await response.json();
    return flattenAttributes(response);
  } catch (error) {
    throw error;
  }
};

export default getRequest;

export const makeApiRequest = async (
  url,
  method,
  body,
  tags,
  cache = false
) => {
  try {
    const response = await fetch(url, {
      method: method,
      headers: {
        "Content-Type": "application/json",
        Authorization: `Bearer ${strapiApiKey}`,
      },
      body: body ? JSON.stringify(body) : null,
      ...(method === "GET"
        ? { next: { revalidate: 300 } }
        : { cache: "no-store" }),
    });

    const data = await response.json();
    const flattenedResponse = flattenAttributes(data);

    if (!response.ok) {
      throw new Error(data?.error?.message || "Something went wrong");
    }

    return flattenedResponse;
  } catch (error) {
    return { error: error?.response?.message };
  }
};

export const getRequestNew = async (
  url,
  options = {},
  cache = false,
  revalidate = false
) => {
  if (options && options?.lang) {
    // Determine if the URL already has query parameters
    const separator = url.includes("?") ? "&" : "?";
    // Append the lang parameter to the URL
    url += `${separator}locale=${options.lang}`;
  }

  options.headers = {
    Authorization: `Bearer ${strapiApiKey}`,
  };

  try {
    const revalidateSeconds =
      typeof revalidate === "number" ? revalidate : 300;
    let response = await fetch(url, {
      ...options,
      ...(cache
        ? { next: { revalidate: revalidateSeconds } }
        : { cache: "no-store" }),
    });

    response = await response.json();
    return flattenAttributes(response);
  } catch (error) {
    throw error;
  }
};

export const getRequestNewWithCacheOption = async (
  url,
  options = {},
  cache = false,
  revalidate = false,
  cacheValue
) => {
  if (options && options?.lang) {
    // Determine if the URL already has query parameters
    const separator = url.includes("?") ? "&" : "?";
    // Append the lang parameter to the URL
    url += `${separator}locale=${options.lang}`;
  }

  options.headers = {
    Authorization: `Bearer ${strapiApiKey}`,
  };

  try {
    let response = await fetch(url, {
      ...options,
      ...(cacheValue ? { cache: cacheValue } : {}),
      // next: cache && revalidate ? { revalidate: 3600 * 6 } : {},
    });

    response = await response.json();
    return flattenAttributes(response);
  } catch (error) {
    throw error;
  }
};
